<template>
    <div class="card h-auto card-filled card--white">
        <ul class="settings-list m-0 list-unstyled color--black pb-4">
            <li
                v-for="(translation, setting) in settings"
                :key="setting"
                :class="{ active: setting === value }"
                class="h2"
                @click="setActiveTab(setting)"
            >
                {{ translation }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },

        settings: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    methods: {
        setActiveTab(setting) {
            this.$emit('input', setting);
        }
    }
};
</script>

<style lang="scss" scoped>
.settings-list li {
    padding-left: 30px;
    line-height: 1.75;
    margin: 0;
}

.settings-list li:hover,
.settings-list li.active {
    color: $brand-white;
    background-color: $brand-blue;
    cursor: pointer;
}
</style>
